export default "__VITE_ASSET__0bd95074__"